import { z } from 'zod';

export const uploadableScheme = z.object({
  url: z.string(),
  size: z.number(),
  name: z.string(),
  type: z.string(),
  compress: z.boolean().default(false),
});

export type Uploadable = z.infer<typeof uploadableScheme>;

export function convertBlobToUploadable(blob: Blob, filename = 'unknown.blob'): Uploadable {
  return {
    url: URL.createObjectURL(blob),
    name: filename,
    size: blob.size,
    type: blob.type,
    compress: true,
  };
}

export function convertFileToUploadable(file: File): Uploadable {
  return {
    url: URL.createObjectURL(file),
    name: file.name,
    size: file.size,
    type: file.type,
    compress: false,
  };
}

export async function convertUploadableToFile(uploadable: Uploadable): Promise<File> {
  const fileBlob = await fetch(uploadable.url).then((res) => res.blob());

  return new File([fileBlob], uploadable.name, { type: uploadable.type });
}

export function convertUrlToUploadable(url: string | URL): Uploadable {
  return {
    url: url.toString(),
    name: '',
    size: 0,
    type: '',
    compress: false,
  };
}
